module.exports = __webpack_public_path__ + "img/paterNewMobile.20d7cb08.png";